<template>
  <div class="infor fl">
    <div class="infor-t clearfix">
      <div class="fl infor-t-l">
        <img v-if="ischage" src="../assets/xiugai.png" />
        <!-- {{member.name}} -->
        {{ ischage ? "修改基本信息" : "账户已完善资料概览" }}
      </div>
      <div class="fr infor-t-r" @click="changeinfo()" v-show="!ischage">
        <img style="margin-right: 3px;" src="../assets/19.png" alt="" />
        <span>编辑基本信息</span>
      </div>
    </div>
    <div v-show="!ischage">
      <Lineconbgtir
        :labelcontainer="labelcontaineragain"
        style="margin-top: 20px"
      />
      <div style="display: flex; margin-top: 16px">
        <div>
          <div style="display: flex">
            <div>
				<div class="tablebox">
				  <div class="thbox-597">
                      <div class="tdbox">账号名称<span style="color: #FF4D4D">*</span></div>
					<div class="tdbox">{{ member.name }}</div>
				  </div>
				</div>
				<div class="tablebox">
				  <div class="thbox-597">
					<div class="tdbox">企业名称<span style="color: #FF4D4D">*</span></div>
					<div class="tdbox">{{ member.enterprise_name }}</div>
				  </div>
				</div>
				<div class="tablebox">
				  <div class="thbox-597">
					<div class="tdbox">单位地址<span style="color: #FF4D4D">*</span></div>
					<div class="tdbox">{{ member.address }}</div>
				  </div>
				</div>
            </div>
            <div class="tablebox">
              <div class="thbox-289">
                <div class="tdbox">营业执照</div>
                <div class="tdbox">
                  <img
                      class="certifications"
                      v-if="member.business_license"
                      :src="member.business_license"
                      alt=""
                    />
                  <div class="business" v-if="!member.business_license">
                    <img

                      class="Businesscertificate"
                      src="@/assets/6952@2x.png"
                      alt=""
                    />
                    <p
                      style="color: #9fa5ae; font-size: 16px"
                    >
                      未上传营业执照
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tablebox">
            <div class="thbox-337">
              <div class="tdbox">统一社会信用代码<span style="color: #FF4D4D">*</span></div>
              <div class="tdbox">{{ member.unified_social_credit_code }}</div>
            </div>
            <div class="thbox-260">
              <div class="tdbox">法定代表人<span style="color: #FF4D4D">*</span></div>
              <div class="tdbox">{{ member.legal_representative }}</div>
            </div>
            <div class="thbox-260">
              <div class="tdbox">证件号<span style="color: #FF4D4D">*</span></div>
              <div class="tdbox">{{ member.legal_representative_id }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tablebox">
        <div class="thbox-142">
          <div class="tdbox">企业性质<span style="color: #FF4D4D">*</span></div>
          <div class="tdbox">{{ member.enterprise_nature }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">是否上市</div>
          <div class="tdbox">{{ member.is_list == 1 ? "是" : "否" }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">成立时间<span style="color: #FF4D4D">*</span></div>
          <div class="tdbox">
            {{
              member.established_time != null
                ? member.established_time.slice(0, 10)
                : ""
            }}
          </div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">注册资本</div>
          <div class="tdbox">{{ member.registered_capital }}</div>
        </div>
        <div class="thbox-284">
          <div class="tdbox">联系电话<span style="color: #FF4D4D">*</span></div>
          <div class="tdbox">{{ member.contact_number }}</div>
        </div>
      </div>
      <!-- 基本介绍 -->
      <Lineconbgtir :labelcontainer="Corporateinfo" style="margin-top: 20px" />
      <div class="tablebox" style="margin-top: 16px">
        <div class="thbox-142">
          <div class="tdbox">法定代表人手机号<span style="color: #FF4D4D">*</span></div>
          <div class="tdbox">{{ member.other_phone }}</div>
        </div>
          <div class="thbox-142">
              <div class="tdbox">文化程度<span style="color: #FF4D4D">*</span></div>
              <div class="tdbox">{{ member.education_degree }}</div>
          </div>
          <div class="thbox-142">
              <div class="tdbox">职业资格水平<span style="color: #FF4D4D">*</span></div>
              <div class="tdbox">{{ member.professional_qualification_level }}</div>
          </div>
          <div class="thbox-142">
              <div class="tdbox">政治面貌</div>
              <div class="tdbox">{{ member.political_outlook }}</div>
          </div>
          <div class="thbox-284">
              <div class="tdbox">党组织关系所在单位</div>
              <div class="tdbox">{{ member.company }}</div>
          </div>
      </div>
      <Lineconbgtir
        :labelcontainer="{ lable: '联系人信息', desc: 'contact information' }"
        style="margin-top: 20px"
      />
      <div class="tablebox" style="margin-top: 16px">
        <div class="thbox-142">
          <div class="tdbox">姓名<span style="color: #FF4D4D">*</span></div>
          <div class="tdbox">{{ member.contact_user_name }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">工作部门<span style="color: #FF4D4D">*</span></div>
          <div class="tdbox">{{ member.contact_work_department }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">职务<span style="color: #FF4D4D">*</span></div>
          <div class="tdbox">{{ member.contact_post }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">固定电话</div>
          <div class="tdbox">{{ member.contact_fixed_telephone }}</div>
        </div>
        <div class="thbox-142">
          <div class="tdbox">移动电话<span style="color: #FF4D4D">*</span></div>
          <div class="tdbox">{{ member.contact_mobile_phone }}</div>
        </div>
      </div>
      <Lineconbgtir
        :labelcontainer="{ lable: '基本介绍', desc: 'basic introduction' }"
        style="margin-top: 20px"
      />
      <p style="text-align: start; margin-top: 16px; line-height: 30px">
        {{ member.introduce }}
      </p>
      <div>
        <Lineconbgtir
          :labelcontainer="{ lable: '荣誉奖项', desc: 'honorary award' }"
          style="margin-top: 20px"
        />
        <div class="swiper-container scroll" id="swiper2">
          <div class="swiper-wrapper">
            <a
              v-for="(item, index) in prizeList"
              :key="index"
              class="swiper-slide swiper-slide-avatar"
              href="./personal.html"
              target="_blank"
            >
              <img class="" :src="item.img_url" alt="" />
            </a>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <div v-show="ischage">
      <CompanInfo :member="member" @isCompanInfo="isCompanInfo" />
    </div>
  </div>
</template>

<script>
import Lineconbgtir from "./Modal/Line";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import CompanInfo from "./Modal/CompanInfo";
import { GetMember, PrizeList } from "../utils/api.js";
export default {
  name: "ForgetHit",
  components: {
    CompanInfo,
    Lineconbgtir,
  },
  props: {},
  data() {
    return {
      labelcontaineragain: {
        lable: "企业信息",
        desc: "Corporate Information",
      },
      Corporateinfo: {
        lable: "法人信息",
        desc: "Legal representative information",
      },
      prizeList: [],
      list: [20],
      ischage: false,
      title: "贵州华盈建筑集团",
      member: {
        name: "",
        contact_number: "",
        unified_social_credit_code: "",
        enterprise_nature: "",
        is_list: "",
        established_time: "",
        registered_capital: "",
        legal_representative: "",
        business_license: "",
      },
    };
  },
  created() {},
  async mounted() {
    var swiper = Swiper("#swiper2", {
      observer: true,
      observeParents: true,
      slidesPerView: 9,
      spaceBetween: 0,
      loop: true,
      prevButton: ".swiper-button-prev",
      nextButton: ".swiper-button-next",
      autoplay: 1000, //可选选项，自动滑动
      freeMode: true,
    });
    let member = await GetMember();
    let prizeList = await PrizeList();
    console.log(789, member);

    this.prizeList = prizeList;
    this.member = member;
    if (this.$route.query) {
      this.ischage = false;
    }
  },
  methods: {
    isCompanInfo(v) {
      this.ischage = v;
    },
    changeinfo() {
      this.ischage = true;
      this.title = "修改基本资料";
    },
  },
};
</script>
<style lang="less" scoped>
.infor {
  &-t {
    // padding: 14px;
    padding-top: 14px;
    border-bottom: 1px solid #d4dbdd;

    &-l {
      font-size: 28px;
      color: #181e23;
      display: inline-block;
      padding-bottom: 14px;
      font-weight: bold;
      border-bottom: 2px solid #194abe;
    }

    &-r {
      width: 128px;
      height: 31px;
      background: linear-gradient(90deg, #3D63DF 0%, #3D63DF 10%, #FF8640 100%);
        border-radius: 4px 4px 4px 4px;
      opacity: 1;
      overflow: hidden;
      display: table-cell;
      line-height: 31px;
      cursor: pointer;

      img {
        vertical-align: middle;
      }

      span {
        color: #ffffff;
        font-size: 14px;
      }
    }
  }

  &-c {
    text-align: justify;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #565656;
    padding: 10px 0px;
  }

  &-img {
    text-align: center;
    padding: 24px 0px 40px 0px;
  }
}
.tablebox {
  display: flex;
  .thbox-337,
  .thbox-260,
  .thbox-570,
  .thbox-288,
  .thbox-289,
  .thbox-142,
  .thbox-597,
  .thbox-284 {
    .tdbox {
      box-sizing: border-box;
      margin: -1px -1px 0 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      overflow: hidden;
      &:nth-child(1) {
        height: 32px;
        background: #f5f9fb;
        height: 32px;
        padding: 0px;
        color: #9FA6AF;
        padding-left: 17px;
        border: 1px solid #d4dedd;
      }
      &:nth-child(2) {
        height: 50px;
        background: #fff;
        color: #333333;
        font-weight: bold;
        font-size: 16px;
        padding-left: 17px;
        border: 1px solid #d4dedd;
      }
      .certifications{
        height: 112px;
        margin: 0 auto;
      }
      .business {
        cursor: pointer;
        margin: 0 auto;
        width: 150px;
        height: 112px;
        background: #f1f1f1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        .Businesscertificate {
          width: 97px;
          height: 72px;
        }
      }
    }
  }
    .thbox-597 {
        width: 597px;
    }
  .thbox-337 {
    width: 337px;
  }
  .thbox-260 {
    width: 260px;
  }
  .thbox-570 {
    width: 570px;
  }
  .thbox-142 {
    width: 143px;
  }
  .thbox-284 {
    width: 284px;
  }
  .thbox-288 {
    width: 260px;
    .tdbox:nth-child(2) {
      height: 130px;
      padding: 0;
    }
  }
  .thbox-289 {
    width: 260px;
    .tdbox:nth-child(2) {
      height: 210px;
      padding: 0;
    }
  }
}
.yearlist {
  display: flex;
  flex-direction: column;
  align-items: center;
  .list {
    margin-top: 16px;
    position: relative;
    width: 858px;
    height: 110px;
    display: flex;
    border: 1px dashed #c8cdd5;
    .output,
    .Numberpersonnel {
      width: 402px;
      height: 110px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .title {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
        span {
          display: inline-block;
          margin-right: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
        }
        .yellow {
          background: #f58e19;
          color: #f58e19;
        }
        .red {
          background: #e16068;
          color: #e16068;
        }
        .blue {
          background: #4c6dbb;
          color: #4c6dbb;
        }
      }
      .count {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 24px;
        color: #7c828a;
        span {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: 40px;
        }
        .yellow {
          color: #f58e19;
        }
        .red {
          color: #e16068;
        }
        .blue {
          color: #4c6dbb;
        }
      }
    }
    .Numberpersonnel {
      width: 306px;
      background: #f5f9fb;
      .count span {
        color: #414141;
      }
      .title {
        .green {
          background: #25a0b9;
        }
        .graygreen {
          background: #adc263;
        }
      }
    }
    .leftimg {
      position: absolute;
      left: 0;
      top: 0;
      width: 150px;
      height: 110px;
    }
    .leftyear {
      width: 150px;
      height: 110px;
      line-height: 110px;
      font-size: 43px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      position: relative;
      z-index: 1;
    }
  }
}
.block-title {
  width: 842px;
  padding-left: 14px;
    background:url("../assets/6948.png");
  height: 40px;
  font-size: 20px;
  font-weight: bold;
  color: #1852c7;
  text-align: left;
  display: table-cell;
  vertical-align: middle;

  span {
    margin-right: 20px;
  }

  span:nth-child(2) {
    font-size: 14px;
    color: #9fa5ae;
  }
}

.scroll {
  position: relative;
  height: 226px;
  // background: url(../image/juxin.png)no-repeat;
  text-align: left;
}

.swiper-wrapper {
  display: flex;
  justify-content: center;
}

.swiper-wrapper-avatar {
  position: relative;
  width: 107px;
  height: 100%;
}

.swiper-slide-avatar {
  height: 226px;
  height: 143px;
  display: inline-block;
  width: 260px !important;
  margin-left: 14px;
}

.swiper-slide-avatar img {
  width: 260px !important;
  height: 143px;
  margin-top: 22px;
}

.swiper-slide-avatar p {
  text-align: center;
  margin-top: 13px;
  font-size: 13px;
}

.swiper-slide-avatar span {
  display: block;
  text-align: center;
  margin-top: 6px;
  color: #8c8076;
  font-size: 12px;
}

.margin-left-30 {
  margin-left: 30px;
}

.infor-img img {
  width: 454px;
  height: 341px;
}

/*Swiper原样式 */
.swiper-button-next {
  background-image: url("../assets/22.png");
}

.swiper-button-prev {
  background-image: url("../assets/21.png");
}

.swiper-button-prev {
  position: absolute;
  top: 50%;
  width: 31px;
  height: 62px;
  margin-top: -31px;
  z-index: 10;
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
  left: 0px;
}

.swiper-button-next {
  position: absolute;
  top: 50%;
  width: 31px;
  height: 62px;
  margin-top: -31px;
  z-index: 10;
  right: 0px;
  cursor: pointer;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
